import { areaChartBuilder } from './highchart-based-charts/cartesians/stackable/area-chart/area-chart-builder.js';
import { barChartBuilder } from './highchart-based-charts/cartesians/stackable/bar-chart/bar-chart-builder.js';
import { columnChartBuilder } from './highchart-based-charts/cartesians/stackable/column-chart/column-chart-builder.js';
import { lineChartBuilder } from './highchart-based-charts/cartesians/line-chart/line-chart-builder.js';
import { polarChartBuilder } from './highchart-based-charts/cartesians/polar-chart/polar-chart-builder.js';
import { pieChartBuilder } from './highchart-based-charts/categoricals/pie-chart/pie-chart-builder.js';
import { funnelChartBuilder } from './highchart-based-charts/categoricals/funnel-chart/funnel-chart-builder.js';
import { treemapChartBuilder } from './highchart-based-charts/categoricals/treemap-chart/treemap-chart-builder.js';
import { sunburstChartBuilder } from './highchart-based-charts/categoricals/sunburst-chart/sunburst-chart-builder.js';
import { calendarHeatmapChartBuilder } from './highchart-based-charts/calendar-heatmap-chart/calendar-heatmap-chart-builder.js';
import { registerChartBuilder as registerBuilder, getChartBuilder } from './chart-builder-registry.js';
import type { ChartBuilder, SupportedChartType } from './types.js';

const defaultChartBuilders: Array<[SupportedChartType, ChartBuilder<SupportedChartType>]> = [
  ['area', areaChartBuilder],
  ['column', columnChartBuilder],
  ['bar', barChartBuilder],
  ['line', lineChartBuilder],
  ['polar', polarChartBuilder],
  ['pie', pieChartBuilder],
  ['funnel', funnelChartBuilder],
  ['treemap', treemapChartBuilder],
  ['sunburst', sunburstChartBuilder],
  ['calendar-heatmap', calendarHeatmapChartBuilder],
];

defaultChartBuilders.forEach(([chartType, builder]) => {
  registerBuilder(chartType, builder as ChartBuilder<SupportedChartType>);
});

export { getChartBuilder };
export { registerChartBuilder } from './chart-builder-registry.js';
